<template>
    <div class="control-option-container">

        <div class="option-control drag-item"
             title="Re-position / Drag"
             v-show="permissions.canReOrderingControl">
            <span v-html="$form.getIcon('navigationMore', '24px', '24px', '#f1c40f')"></span>
        </div>

        <div class="option-control"
             title="Control Configuration"
             v-show="permissions.canEditControl"
             @click="clickedConfiguration">
            <span v-html="$form.getIcon('cog', '24px', '24px', '#3498db')"></span>
        </div>

        <div class="option-control"
             title="Duplicate Control"
             v-show="permissions.canAddControl"
             @click="clickedDuplicate">
            <span v-html="$form.getIcon('contentCopy', '24px', '24px', '#2ecc71')"></span>
        </div>

        <div class="option-control"
             title="Move to..."
             v-show="permissions.canReOrderingControl"
             @click="clickedMove">
            <span v-html="$form.getIcon('move', '24px', '24px', '#9b59b6')"></span>
        </div>

        <div class="option-control"
             title="Delete Control"
             v-show="permissions.canDeleteControl"
             @click="clickedDelete">
            <span v-html="$form.getIcon('trash', '24px', '24px', '#e74c3c')"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ControlOption",
        props: {
            permissions: Object
        },
        methods: {
            /**
             * Emit to parent to delete this control...
             */
            clickedDelete() {
                this.$emit('delete', true)
            },

            /**
             * Emit to parent to open the configuration
             */
            clickedConfiguration() {
                this.$emit('config', true)
            },

            /**
             * Emit to parent to duplicate this control
             */
            clickedDuplicate() {
                this.$emit('duplicate', true)
            },

            /**
             * Emit to parent to move this control to another section/position
             */
            clickedMove() {
                this.$emit('move', true)
            }
        },
    }
</script>